import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "maintenance-page" }
const _hoisted_2 = {
  class: "maintenance-card",
  "aria-live": "polite"
}
const _hoisted_3 = {
  class: "maintenance-countdown",
  "aria-label": "Temps avant la prochaine vérification"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "maintenance-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "maintenance-icon",
        "aria-hidden": "true"
      }, [
        _createElementVNode("i", { class: "fa fa-gear" })
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Maintenance en cours", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "Maintenance en cours, veuillez patienter quelques minutes", -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formattedCountdown), 1),
      _createElementVNode("button", {
        type: "button",
        class: "maintenance-check-button",
        disabled: _ctx.isChecking,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkMaintenance && _ctx.checkMaintenance(...args)))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fa", _ctx.isChecking ? 'fa-spinner fa-spin' : 'fa-rotate'])
        }, null, 2),
        _createElementVNode("span", null, _toDisplayString(_ctx.isChecking ? 'Vérification...' : 'Vérifier maintenant'), 1)
      ], 8, _hoisted_4),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}